
import {
  GET_SALES_REPORT_ORDER_PRINT_REQUEST,
  GET_SALES_REPORT_ORDER_PRINT_SUCCESS,
  GET_SALES_REPORT_ORDER_PRINT_ERROR,
} from "../actions/types";


export const salesReportOrderPrint = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SALES_REPORT_ORDER_PRINT_REQUEST:
      return {
        loading: true,
      };
    case GET_SALES_REPORT_ORDER_PRINT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SALES_REPORT_ORDER_PRINT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};